import SectionHeading from './SectionHeading';
import { movies } from '@/mocks/movies';

export default function MoviePicks() {
  return (
    <section id="movie" className="scroll-mt-16 bg-background-50 py-14 md:py-20 border-t border-background-200/70">
      <div className="px-4 md:px-8">
        <SectionHeading
          icon="ri-movie-2-line"
          eyebrow="电影精选"
          title="电影：剧情、文艺与类型片的横向挑选"
          desc="与按集更新的剧集不同，电影条目一次看完，这里按题材、年份与时长整理，并标注关键标签，方便你按当晚的心情选片。"
        />

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {movies.map((movie) => (
            <article
              key={movie.id}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200 transition-colors hover:border-primary-300"
            >
              <div className="w-full aspect-[3/4] bg-background-200 overflow-hidden">
                <img
                  src={movie.poster}
                  alt={`《${movie.title}》电影海报`}
                  className="w-full h-full object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{movie.title}</h3>
                  <span className="shrink-0 px-2 py-0.5 text-xs font-bold rounded-md bg-primary-500 text-background-50">
                    {movie.rating}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  {movie.genre} · {movie.year} · {movie.duration}
                </p>
                <p className="mt-2 text-xs leading-5 text-foreground-600">{movie.note}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {movie.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-900">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}